import { render, staticRenderFns } from "./DowngradeModal.vue?vue&type=template&id=0218a318&scoped=true&"
import script from "./DowngradeModal.vue?vue&type=script&lang=ts&"
export * from "./DowngradeModal.vue?vue&type=script&lang=ts&"
import style0 from "./DowngradeModal.vue?vue&type=style&index=0&id=0218a318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218a318",
  null
  
)

export default component.exports